import React from 'react'
import styled from 'styled-components'
import { container } from '../../styles/reusable.style'

const StyledContainer = styled.div`
	${container};
`
const Container = props => (
	<StyledContainer className="container" {...props}>
		{props.children}
	</StyledContainer>
)

export default Container
